export default "<!-- <p>\n  Redirecionando do app para a tela de sinais ...\n</p> -->\n"